import {
  PERMISSIONS,
  can,
  deniedActions,
} from "../../../shared/permissions/index.js";
import { bumpActionsFor } from "../../../shared/products/bump.js";
import SignType from "../signType";

const { PRODUCT_SET_FIXED_BUMP: SET } = PERMISSIONS;

const isAllowed = ({ user, stored, requested }) =>
  deniedActions(bumpActionsFor({ existing: stored, requested }), stored, user)
    .length === 0;

export const fixedBumpControlsFor = ({ user, stored, current }) => {
  const visible = Boolean(user.isAdmin) || can(SET, stored, user);
  const toggled = { ...current, fixedBump: !current.fixedBump };

  return {
    visible,
    canToggle:
      visible &&
      current.signedType !== SignType.inPerson &&
      isAllowed({ user, stored, requested: toggled }),
    canEditAmount:
      visible && Boolean(current.fixedBump) && can(SET, stored, user),
  };
};
